import template from "./contact-card.html";

const ContactCardComponent = {
  bindings: {
    contact: "<",
    searchText: "<",
    onChange: "&",
  },
  template: template,
  controller: class ContactCardController {
    /* @ngInject */
    constructor($rootScope, $filter, Contact, Notification, SweetAlertService, ModalsManager) {
      this.$rootScope = $rootScope;
      this.$filter = $filter;
      this.Contact = Contact;
      this.NotificationService = Notification;
      this.SweetAlertService = SweetAlertService;
      this.ModalsManager = ModalsManager;
    }

    async openEditContactForm() {
      const contact = await this.ModalsManager.openContactModal(this.contact, true);
      if (contact) this.onChange();
    }

    async delete() {
      if (!(await this.SweetAlertService.contactWillBeDeleted())) return;

      await this.contact.delete();
      this.NotificationService.success({
        title: this.$filter("trans")("notificationService.title.success"),
        message: this.$filter("trans")("notificationService.message.deleteContact"),
      });
      this.onChange();
    }
  },
};

export default ContactCardComponent;
